<template>
  <div class="overflow-visible text-transparent ds-text-xs font-normal">
    <span
      class="block overflow-hidden text-gray-500 whitespace-no-wrap ellipsis"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "styles/_media.scss";
span {
  max-width: calc(300px - 4rem);
  @include md-down {
    max-width: 100%;
  }
}
</style>